const baseUrl = process.env.REACT_APP_BASE_URL;

const seoData = {
  home: {
    title: "Giraffic Info World | Software, Web & SEO Company in India",
    description:
      "Giraffic Info World is a leading software, web development, SEO and digital marketing company offering customized IT solutions.",
    keywords:
      "software company india, web development company, seo company, digital marketing services",
    url: `${baseUrl}/`,
  },

  about: {
    title: "About Giraffic Info World | IT & Software Company in Thuckalay",
    description:
      "Learn about Giraffic Info World, a trusted IT and software development company in Thuckalay, Tamil Nadu offering web development, ERP, SEO, automation and internship programs.",
    keywords:
      "About Giraffic Info World, IT company in Thuckalay, software company in Tamil Nadu",
    url: `${baseUrl}/about`,
  },

  internship: {
    title: "Software Internship in Tamil Nadu | Giraffic Info World",
    description:
      "Join the internship program at Giraffic Info World in Thuckalay. We offer IT, software, web development, and digital marketing internships for students.",
    keywords:
      "software internship tamil nadu, web development internship, seo internship, react internship",
    url: `${baseUrl}/internship`,
  },

  services: {
    title: "IT Services in Thuckalay | Web, Software & SEO – Giraffic Info World",
    description:
      "Giraffic Info World offers professional IT services in Thuckalay including web development, software & ERP solutions, SEO, digital marketing, mobile app development and automation services across Tamil Nadu.",
    keywords:
      "IT services in Thuckalay, software company in Tamil Nadu, web development company in Kanyakumari, SEO services in Tamil Nadu",
    url: `${baseUrl}/services`,
  },

  careers: {
    title: "Careers & Internship in Thuckalay | Software Jobs – Giraffic Info World",
    description:
      "Apply for software jobs and internships at Giraffic Info World, a leading IT company in Thuckalay, Tamil Nadu. Openings for freshers, developers, and interns.",
    keywords:
      "software internship in Tamil Nadu, IT company careers in Thuckalay, react internship, freshers software jobs",
    url: `${baseUrl}/careers`,
  },

  features: {
    title: "Why Choose Giraffic Info World | Trusted IT Company in Tamil Nadu",
    description:
      "Discover why Giraffic Info World is a preferred IT company in Thuckalay, Tamil Nadu. Client-focused approach, expert team, scalable solutions and reliable support.",
    keywords:
      "why choose giraffic info world, IT company in Thuckalay, software company in Tamil Nadu",
    url: `${baseUrl}/features`,
  },

  gallery: {
    title: "Portfolio & Projects | Giraffic Info World – IT Company in Tamil Nadu",
    description:
      "Explore the portfolio of Giraffic Info World showcasing web development, ERP, mobile apps, automation, and digital marketing projects delivered across Tamil Nadu.",
    keywords:
      "IT company portfolio, software development projects, web development company in Thuckalay, ERP projects Tamil Nadu",
    url: `${baseUrl}/gallery`,
  },

  contact: {
    title: "Contact Giraffic Info World | IT & Software Company in Thuckalay",
    description:
      "Contact Giraffic Info World – a leading IT & software development company in Thuckalay, Tamil Nadu. Get in touch for web development, ERP, automation, and digital solutions.",
    keywords:
      "contact IT company, software company in Thuckalay, web development company near me, Giraffic Info World contact",
    url: `${baseUrl}/contact`,
  },
};

export default seoData;
